import { Outlet, Link } from "react-router-dom";
import { Wordmark } from "@/components/app/Logo";
import { ThemeToggle } from "@/components/app/ThemeToggle";
import { Footer } from "@/components/app/Footer";
import { ExamBackdrop } from "@/components/app/ExamBackdrop";

export function AuthLayout() {
  return (
    <div className="relative flex min-h-screen flex-col">
      {/* Atmospheric background: soft gradient glow, then the
          exam-themed vector backdrop (ruled paper + motifs). */}
      <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 bg-brand-glow" />
      <ExamBackdrop />

      <a href="#main" className="skip-link">
        Skip to main content
      </a>

      <header className="relative flex items-center justify-between px-6 py-5 pt-[max(1.25rem,env(safe-area-inset-top))]">
        <Link to="/" aria-label="ExamBase home">
          <Wordmark size="md" />
        </Link>
        <ThemeToggle />
      </header>

      <main
        id="main"
        tabIndex={-1}
        role="main"
        className="relative flex flex-1 items-center justify-center px-4 py-10"
      >
        <div className="w-full max-w-md">
          <div className="mb-6 text-center">
            <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-accent-foreground">
              UK Functional Skills
            </p>
            <h1 className="mt-1 font-serif text-xl font-semibold tracking-tight text-foreground [text-wrap:balance] sm:text-2xl">
              Author, deliver and mark functional skills assessments
            </h1>
            <p className="mt-1 text-xs text-muted-foreground">
              Reading, Writing, Speaking and Listening: one workspace.
            </p>
          </div>
          <Outlet />
        </div>
      </main>

      <Footer variant="auth" />
    </div>
  );
}
